import { m as e, c as t } from "./sharedStyles.js";
import { jsxs as i, jsx as a, Fragment as n } from "react/jsx-runtime";
import { uniqueId as r } from "@wds/utils";
import { IconChartConfidenceLevel as s } from "@wds/icons";
import { createUseStyles as o } from "react-jss";
import { T as l, a as d, b as c } from "./TableDataCell.js";

const h = () => i("svg", Object.assign({
  width: "10px",
  height: "10px",
  viewBox: "0 0 10 10",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: [a("title", {
    children: "stat-sig-decrease"
  }), a("defs", {
    children: a("filter", Object.assign({
      id: "filter-1"
    }, {
      children: a("feColorMatrix", {
        in: "SourceGraphic",
        type: "matrix",
        values: "0 0 0 0 0.968627 0 0 0 0 0.549020 0 0 0 0 0.392157 0 0 0 1.000000 0"
      })
    }))
  }), a("g", Object.assign({
    id: "Chart-Visualizations-(WIP)",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, {
    children: a("g", Object.assign({
      id: "NPS-|-Multiple-waves-|-Table",
      transform: "translate(-647.000000, -802.000000)"
    }, {
      children: a("g", Object.assign({
        id: "Data-Viz-Card",
        transform: "translate(72.000000, 303.000000)"
      }, {
        children: a("g", Object.assign({
          id: "Table",
          transform: "translate(53.000000, 178.000000)"
        }, {
          children: a("g", Object.assign({
            id: "Group-2",
            transform: "translate(319.000000, 317.000000)"
          }, {
            children: a("g", Object.assign({
              id: "Group-4",
              transform: "translate(203.000000, 0.000000)"
            }, {
              children: a("g", Object.assign({
                id: "stat-sig-decrease",
                transform: "translate(0.000000, 4.000000)",
                filter: "url(#filter-1)"
              }, {
                children: a("g", {
                  children: a("path", {
                    d: "M9,0.414213562 C9.55228475,0.414213562 10,0.861928813 10,1.41421356 L10,9 C10,9.55228475 9.55228475,10 9,10 C8.73478351,10 8.4804296,9.89464316 8.29289322,9.70710678 L0.707106781,2.12132034 C0.316582489,1.73079605 0.316582489,1.09763107 0.707106781,0.707106781 C0.89464316,0.519570403 1.14899707,0.414213562 1.41421356,0.414213562 L9,0.414213562 Z",
                    id: "Combined-Shape",
                    fill: "#F78C64",
                    transform: "translate(5.207107, 5.207107) rotate(-270.000000) translate(-5.207107, -5.207107) "
                  })
                })
              }))
            }))
          }))
        }))
      }))
    }))
  }))]
})),
      g = () => i("svg", Object.assign({
  width: "10px",
  height: "10px",
  viewBox: "0 0 10 10",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: [a("title", {
    children: "stat-sig-increase"
  }), a("g", Object.assign({
    id: "Chart-Visualizations-(WIP)",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, {
    children: a("g", Object.assign({
      id: "NPS-|-Multiple-waves-|-Table",
      transform: "translate(-835.000000, -802.000000)",
      fill: "#44CE94"
    }, {
      children: a("g", Object.assign({
        id: "Data-Viz-Card",
        transform: "translate(72.000000, 303.000000)"
      }, {
        children: a("g", Object.assign({
          id: "Table",
          transform: "translate(53.000000, 178.000000)"
        }, {
          children: a("g", Object.assign({
            id: "Group-2",
            transform: "translate(319.000000, 317.000000)"
          }, {
            children: a("g", Object.assign({
              id: "Group-5",
              transform: "translate(391.000000, 0.000000)"
            }, {
              children: a("g", Object.assign({
                id: "Combined-Shape",
                transform: "translate(0.000000, 4.000000)"
              }, {
                children: a("path", {
                  d: "M8.99456787,-1.1812773e-13 C9.54685262,-1.18229183e-13 9.99456787,0.44771525 9.99456787,1 L9.99456787,8.58578644 C9.99456787,9.13807119 9.54685262,9.58578644 8.99456787,9.58578644 C8.72935138,9.58578644 8.47499747,9.4804296 8.28746109,9.29289322 L0.701674652,1.70710678 C0.311150361,1.31658249 0.311150361,0.683417511 0.701674652,0.292893219 C0.889211031,0.10535684 1.14356494,-1.16746743e-13 1.40878143,-1.1812773e-13 L8.99456787,-1.1812773e-13 Z",
                  transform: "translate(5.201675, 4.792893) rotate(-360.000000) translate(-5.201675, -4.792893) "
                })
              }))
            }))
          }))
        }))
      }))
    }))
  }))]
})),
      p = o(({
  type: e
}) => ({
  table: {
    fontFamily: e.fontFamily.base,
    fontSize: e.fontSize.bodySm,
    fontWeight: e.fontWeight.regular,
    color: "#6B787F",
    margin: "auto",
    borderSpacing: "20px"
  },
  icon: {
    height: "16px",
    width: "16px",
    marginRight: "6px",
    verticalAlign: "middle"
  }
}));

function f({
  confidenceLevel: e
}) {
  const t = p();
  return a("table", Object.assign({
    className: t.table
  }, {
    children: a("tbody", {
      children: i("tr", {
        children: [i("td", {
          children: [a("span", Object.assign({
            className: t.icon
          }, {
            children: a(s, {
              title: "confidence level icon",
              size: "md"
            })
          })), i("span", Object.assign({
            style: {
              verticalAlign: "middle"
            }
          }, {
            children: ["Confidence level = ", 100 * e, "% "]
          }))]
        }), i("td", {
          children: [a("span", Object.assign({
            className: t.icon
          }, {
            children: a(h, {})
          })), a("span", Object.assign({
            style: {
              verticalAlign: "middle"
            }
          }, {
            children: "= Significant decrease"
          }))]
        }), i("td", {
          children: [a("span", Object.assign({
            className: t.icon
          }, {
            children: a(g, {})
          })), a("span", Object.assign({
            style: {
              verticalAlign: "middle"
            }
          }, {
            children: "= Significant increase"
          }))]
        })]
      })
    })
  }));
}

function m({
  label: e,
  className: t
}) {
  const i = "string" != typeof e,
        n = i ? e.name : e,
        r = i && e.totals;
  return a(l, {
    name: n,
    totals: r || void 0,
    className: t
  });
}

function b({
  options: e,
  row: t,
  index: i
}) {
  var n, r;
  const s = (null === (n = e.fuzzyMatching) || void 0 === n ? void 0 : n.enabled) && t.fuzzyMatching ? {
    tooltip: null === (r = t.fuzzyMatching) || void 0 === r ? void 0 : r.tooltip
  } : void 0,
        o = e.functionFormat && t.function ? {
    handler: t.function,
    type: e.functionFormat,
    description: t.functionDescription
  } : void 0;
  return a(d, {
    name: t.name,
    index: i,
    identifier: e.rowIdentifier,
    color: t.color,
    event: o,
    fuzzyMatching: s
  });
}

function u({
  data: e,
  className: t
}) {
  const n = e.statisticalSignificanceDirection;
  return a(c, Object.assign({
    value: e.rendered || String(e.value),
    className: t
  }, {
    children: n && i("div", Object.assign({
      className: n
    }, {
      children: ["increase" === n && a(g, {}), "decrease" === n && a(h, {})]
    }))
  }));
}

function v({
  row: e
}) {
  return i(n, {
    children: [e.data.map((t, i) => {
      const n = ["data"];
      return i === e.data.length - 1 && n.push("last"), a(u, {
        data: t,
        className: n.join(" ")
      }, r("data-"));
    }), e.changeOverTimeData.map(e => {
      const t = ["change-over-time"];
      return e.value > 0 && t.push("positive"), e.value < 0 && t.push("negative"), a(u, {
        data: e,
        className: t.join(" ")
      }, r("change-over-time-"));
    })]
  });
}

const j = o(i => ({
  multiWaveTable: Object.assign(Object.assign({}, e.table(i)), {
    width: "100%",
    "& th": Object.assign(Object.assign({}, e.th(i)), {
      fontSize: i.type.fontSize.caption,
      minWidth: "52px",
      padding: "12px 12px 8px 12px",
      "&.data": {
        whiteSpace: "nowrap"
      },
      "&.data.last:not(:first-of-type)": {
        borderTop: t.border.dark,
        borderTopLeftRadius: "5px"
      },
      "&.change-over-time": {
        borderTop: t.border.dark,
        borderLeft: t.border.light,
        "&:last-of-type": {
          borderRight: t.border.dark,
          borderTopRightRadius: "5px"
        },
        "&:nth-of-type(2)": {
          borderTop: t.border.dark,
          borderLeft: t.border.dark,
          borderTopLeftRadius: "5px"
        }
      }
    }),
    "& td": Object.assign(Object.assign({}, e.td()), {
      padding: "12px 12px",
      position: "relative",
      "& .increase": {
        position: "absolute",
        top: "-1px",
        right: "2px"
      },
      "& .decrease": {
        position: "absolute",
        bottom: "-1px",
        right: "2px"
      },
      "&:first-child": {
        textAlign: "left",
        padding: "12px 24px 12px 4px",
        "& span": {
          verticalAlign: "middle"
        }
      },
      "&.data:not(.last)": {
        backgroundColor: "#F7F8FA"
      },
      "&.data.last": {
        fontWeight: i.type.fontWeight.medium
      },
      "&.change-over-time": {
        "&.positive": {
          color: "#00bf6f"
        },
        "&.negative": {
          color: "#f05b40"
        }
      },
      "&:not(:first-child)": {
        borderLeft: t.border.light
      },
      "&.change-over-time:last-of-type": {
        borderRight: t.border.dark
      },
      "&.change-over-time:nth-of-type(2)": {
        borderLeft: t.border.dark
      }
    }),
    "& td, & th": {
      borderBottom: t.border.light,
      "&.data.last:not(:first-of-type)": {
        borderLeft: t.border.dark
      }
    },
    "& tr:last-of-type": {
      "& td.data.last, & td.change-over-time": {
        borderBottom: t.border.dark
      }
    },
    "&.narrow": {
      width: "50%"
    },
    "&.medium": {
      width: "66%"
    },
    "&.col2 th:not(:first-child)": {
      width: "22.5%"
    },
    "&.col4 th:not(:first-child)": {
      width: "15%"
    },
    "&.col6 th:not(:first-child)": {
      width: "12%"
    },
    "&.col8 th:not(:first-child)": {
      width: "10%"
    },
    "&.col10 th:not(:first-child)": {
      width: "8%"
    },
    "&.col12 th:not(:first-child)": {
      width: "7%"
    },
    "&.col13 th:not(:first-child)": {
      width: "6%"
    }
  })
}));

function x({
  data: e = [{
    name: "",
    data: [{
      value: 0,
      rendered: "n/a"
    }],
    changeOverTimeData: [{
      value: 0,
      rendered: "n/a"
    }]
  }],
  options: t = {
    pivots: [],
    changeOverTimeLabels: ["YoY"],
    statisticalSignificance: {
      confidenceLevel: .95
    }
  }
}) {
  const s = j(),
        o = e[0].data.length,
        l = [s.multiWaveTable];
  return o < 3 ? l.push("narrow") : o >= 3 && o < 6 && l.push("medium"), o <= 2 ? l.push("col2") : o <= 4 ? l.push("col4") : o <= 6 ? l.push("col6") : o <= 8 ? l.push("col8") : o <= 10 ? l.push("col10") : o <= 12 ? l.push("col12") : l.push("col13"), i(n, {
    children: [o > 1 && a(f, {
      confidenceLevel: null == t ? void 0 : t.statisticalSignificance.confidenceLevel
    }), i("table", Object.assign({
      className: l.join(" ")
    }, {
      children: [a("thead", {
        children: i("tr", {
          children: [t.pivots.map((e, i) => {
            const n = ["data"];
            return i === t.pivots.length - 1 && n.push("last"), a(m, {
              label: e,
              className: n.join(" ")
            }, r("header-"));
          }), t.changeOverTimeLabels.map(e => a(m, {
            label: e,
            className: "change-over-time"
          }, r("change-over-time-header-")))]
        })
      }), a("tbody", {
        children: e.map((e, n) => i("tr", {
          children: [a(b, {
            options: t,
            row: e,
            index: n
          }), a(v, {
            row: e
          })]
        }, r("row-")))
      })]
    }))]
  });
}

export { x as M };